import React, { Component } from 'react';
import '../App.css';

class FooterAll extends Component {
  render() {
    return (
      <footer className="App-footer">
      <p className="Items-footer">Via Don Ambrogio Rocca,<br/> 3/7, 20030, Senago</p>
      <p className="Items-footer">02 9989572 <br/> by Alby & Nico</p>
      <p className="Items-footer">Proprietà intellettuale <br />© Sara Ferraro</p>
      </footer>
    )
  }
}

export default FooterAll;
